export default "__VITE_ASSET__D6H9cwPd__"